import React, { useState, useEffect } from 'react'

import { DotsCircleLoader } from '@reactiveonline/frontend_shared_components'
import RentalListItems from '../../rentals/RentalListItems'

export default function Rental({ item, deviceType, extraData }) {
  const { settings } = item
  const { id, classes, viewType } = settings
  const appProps = extraData

  const [entities, setEntities] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect( () => {
    fetchEntity()
  }, [])

  async function fetchEntity() {
    const entity = settings.item

    if (entity) {
      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: `${ appProps.selectedRentalsPath }?items=${ JSON.stringify([entity]) }`,
        dataType: 'json',
        success: result => {
          if (result.items) {
            setEntities(result.items)
          }
        },
        complete: result => {
          setLoading(false)
        }
      })
    }
  }

  function getViewType() {
    switch (viewType) {
      case 'classic':
        return 'version_one'
      case 'minimalistic':
        return 'version_two'
      case 'luxury':
        return 'version_three'
      case 'list':
        return 'version_four'
    }
  }

  return (
    <div
      id={ id || item.id }
      className={ `rb-rental ${ classes || '' }` }
    >
      <RentalListItems
        appProps={ appProps }
        rentals={ entities }
        rentalListVersion={ getViewType() }
        itemsPerRowClass='one_item'
        itemsPerRow={ 1 }
        parentId={ id || item.id }
        loading={ loading }
      />

      { loading &&
        <div className='flex-box items-center content-center flex-1'>
          <DotsCircleLoader/>
        </div>
      }
    </div>
  )
}
